import React, {Component} from 'react';
import {connect} from 'react-redux';
import SweetAlert from 'sweetalert-react';

import PaymentCards from '../../../components/checkout/PaymentCards';

class PaymentCardsView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      newCardData: {},
      showAlert: false,
      swalParams: {
        title: ""
      }
    }
  }

  render() {
    const {showAlert, swalParams} = this.state;
    return (
      <div>
        <PaymentCards viewMode={'edit'} onDeleteCard={() => {}} onAddCardRequest={() => {}} dispatch={this.props.dispatch}/>
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    )
  }

}

export default connect((state) => {
  return {
    loading: state.getIn(['users', 'loading']),
    error: state.getIn(['users', 'error'])
  };
})(PaymentCardsView);



// WEBPACK FOOTER //
// ./src/containers/settings/payments/PaymentCardsView.js